import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatCommonModule,
  MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  take,
  takeUntil,
} from 'rxjs/operators';
import { fuseAnimations } from 'src/@fuse/animations/index';
import { FuseConfigService } from 'src/@fuse/services/config.service';
import { FuseSharedModule } from 'src/@fuse/shared.module';
import { CountryService } from 'src/app/main/pages/services/country.service';
import { ProspectResponse } from 'src/app/main/pages/services/microservices/response/prospect.response';
import { ProspectService } from 'src/app/main/pages/services/prospect.service';
import { UserService } from 'src/app/main/pages/services/user.service';
import {
  cedulaValidator,
  COLORES,
  confirmPasswordValidator,
  CUSTOM_DATE_FORMATS,
  FRUTAS,
  MASCOTAS,
} from 'src/app/shared';
import { SharedModule } from 'src/app/shared/shared.module';

import { DatePickerComponent } from '../../generals/date-picker/date-picker.component';
import { LoadingComponent } from '../../generals/loading/loading.component';
import { LoadingModule } from '../../generals/loading/loading.module';
import { NumberBoardComponent } from '../../generals/number-board/number-board.component';
import { PinCodeConfig } from '../../generals/pin-code/pin-code-config';
import { PinCodeComponent } from '../../generals/pin-code/pin-code.component';
import { WellcomeComponent } from '../../generals/wellcome/wellcome.component';
import { EconomicActivityProspectRequest } from '../../services/microservices/request/economicActivity.prospect.request';
import { ProspectRequest } from '../../services/microservices/request/prospect.request';
import { ActividadEconomica } from '../../services/microservices/response/actividadEconomica.publico.response';
import { IdentificationResponse } from '../../services/microservices/response/identification.response';
import { MicroResponse } from '../../services/microservices/response/micro.response';
import { UserResponse } from '../../services/microservices/response/user.response';
import { ServicesModule } from '../../services/services.module';
import { ConfirmationComponent } from '../generals/confirmation/confirmation.component';
import { SimpleProspectInfo } from './object-type/SimpleProspectInfo';
import { RegisterStep } from './register-step.enum';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DatePickerComponent,
    FlexLayoutModule,
    FuseSharedModule,
    InfiniteScrollModule,
    LoadingComponent,
    LoadingModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCommonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    NumberBoardComponent,
    PinCodeComponent,
    RouterLink,
    RouterModule,
    ServicesModule,
    SharedModule,
    WellcomeComponent,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None,
  animations: [
    fuseAnimations,
    trigger('stepAnimation', [
      state('in', style({ opacity: 1, transform: 'translateX(0)' })),
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(50px)' }),
        animate('300ms ease-in'),
      ]),
      transition(':leave', [
        animate(
          '300ms ease-out',
          style({ opacity: 0, transform: 'translateX(-50px)' }),
        ),
      ]),
    ]),
  ],
})
export class RegisterComponent implements OnInit, OnDestroy, AfterViewInit {
  key?: string;
  lada!: string;
  email!: string;
  codigo!: string;
  defaultFirstName?: string;
  defaultLastName?: string;
  defaultTelephone = '';
  boardPinCode = '';
  account: any;
  paisSeleccionado!: any;
  prospectDataId = 0;
  step: number = RegisterStep.createAccount;
  paises!: any[];
  paisesFiltrados: any[] = [];
  colores: any[];
  mascotas: any[];
  frutas: any[];
  registerForm: FormGroup;
  cambiarForm!: FormGroup;
  perfilPublico!: Array<ActividadEconomica>;
  perfilProspecto?: ProspectResponse;
  perfilUserId?: IdentificationResponse;
  regiStep: typeof RegisterStep = RegisterStep;
  minDateCarIdExpiration: Date = new Date();
  pinCodeConfig: PinCodeConfig = { isPinCodeBoard: true };
  public filteredPaises: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  @ViewChild(PinCodeComponent) pinCodeComp!: PinCodeComponent;
  @ViewChild(DatePickerComponent) DatePickerComp!: DatePickerComponent;
  isSelectPais: boolean;
  isCompletePaisList = false;
  isInfo!: boolean;
  isFiltroSeguridad!: boolean;
  isFinal!: boolean;
  isRecuperarRegistro!: boolean;
  isValidar!: boolean;
  isPin!: boolean;
  createAccount!: boolean;
  isAlready!: boolean;
  showPassword!: boolean;
  samePassword!: boolean;
  showCVSCountry = false;
  isValidPais!: boolean;
  isShowCambiar!: boolean;
  isEmailRegistered = false;
  showNextButton = false;
  isClassButton = true;
  isLoading = false;
  isSendingMail = false;

  filtersPage = new BehaviorSubject({
    page: 0,
    size: 10,
    sortBy: 'countryName',
    sortDir: 'asc',
    search: '',
  });
  filtersPage$ = this.filtersPage.asObservable();
  @ViewChild('paisSelect') paisSelect!: MatSelect;
  private searchSubject: Subject<string> = new Subject();
  private _unsubscribeAll: Subject<any>;

  // eslint-disable-next-line
  constructor(
    public _dialog: MatDialog,
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private _usersService: UserService,
    private _router: Router,
    private _countryService: CountryService,
    private _prospectService: ProspectService,
  ) {
    this.isSelectPais = true;
    this.loadPaises();
    this.colores = COLORES;
    this.mascotas = MASCOTAS;
    this.frutas = FRUTAS;

    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.registerForm = this._formBuilder.group({
      cedula: [
        '',
        [
          cedulaValidator,
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      fechaExpiracionCedula: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      celular: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      genero: ['', Validators.required],
      paisesId: ['', Validators.required],
      paisesFilter: [''],
      color: ['', Validators.required],
      mascota: ['', Validators.required],
      fruta: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?:(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).*)$',
          ),
        ],
      ],
      passwordConfirm: [
        '',
        [
          Validators.required,
          confirmPasswordValidator('password', 'passwordConfirm'),
        ],
      ],
      pinCode: ['', [Validators.required, Validators.minLength(6)]],
      validado: [false, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this._init();
    this.loadPaises();

    this.searchSubject
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(nombrePais => {
        this.isCompletePaisList = false;
        if (nombrePais.trim() === '') {
          this.filtersPageResets();
          this.loadPaises();
          return;
        }

        this.filtersPage.value.search =
          nombrePais.charAt(0).toUpperCase() +
          nombrePais.slice(1).toLowerCase();
        this.filtersPage.value.page = 0;
        this.loadPaises();
      });
  }

  ngAfterViewInit() {
    this.paisSelect?.openedChange.subscribe(open => {
      if (!open) {
        this.paisSelect.focus();
      }

      const panel = this.paisSelect.panel?.nativeElement;

      if (panel) {
        panel.addEventListener('scroll', this.cargarMasPaises.bind(this));
      }
    });
  }

  _init(): void {
    this.isInfo = false;
    this.isFiltroSeguridad = false;
    this.isFinal = false;
    this.isValidPais = false;
    this.paisSeleccionado = {};
    this.registerForm
      .get('password')
      ?.valueChanges.pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.registerForm.get('passwordConfirm')?.updateValueAndValidity();
      });
  }

  loadPaises(): void {
    if (!this.isCompletePaisList) {
      this._countryService
        .obtenerTodos({ ...this.filtersPage.value })
        .subscribe({
          next: response => {
            this.paises =
              this.filtersPage.value.page === 0
                ? response.content
                : [...this.paises, ...response.content];

            if (response.content.length === 0) {
              this.isCompletePaisList = true;
            }

            this.paisesFiltrados = this.paises.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
          },
          error: error => {
            console.error('Error al cargar los paises: ', error);
          },
        });
    }
  }

  cargarMasPaises(): void {
    this.filtersPage.value.page += 1;
    this.loadPaises();
  }

  buscarPais(event: any): void {
    const nombrePais = (event.target as HTMLInputElement).value;
    this.searchSubject.next(nombrePais);
  }

  openWarningCedula(): void {
    this._dialog.open(ConfirmationComponent, {
      data: {
        texto:
          'No pudimos verificar el numero de cédula: <b>Cédula sin registro de origen</b>',
        titulo: 'VALIDACION DE CEDULA',
      },
    });
  }

  checkCedula(): void {
    const control = this.registerForm['controls']['cedula'];
    const valor = control.value;

    if (valor && valor.length === 10 && control.valid) {
      this.reiniciarMensajesValidacion(control);
      this.DatePickerComp.resetComponent();
      this.buscarPerfilUsuario(valor);
      return;
    }
    if (valor.length === 0) {
      this.reiniciarMensajesValidacion(control);
    }
  }

  buscarPerfilUsuario(cedula: string): void {
    this._usersService.searchCedula(cedula).subscribe({
      next: (cedulaResponse: any) => {
        if (!cedulaResponse && !cedulaResponse?.data) {
          this.isAlready = false;
          this.buscarPerfilProspecto(cedula);
          return;
        }
        const control = this.registerForm['controls']['cedula'];
        this.perfilUserId = cedulaResponse?.data;

        this.defaultFirstName = this.perfilUserId?.firstName;
        this.defaultLastName = this.perfilUserId?.lastName;
        this.isAlready = true;
        this.createAccount = false;
        this.isClassButton = false;
        control.setErrors({ cedulaExiste: true });
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.NotFound) {
          this.buscarPerfilProspecto(cedula);
        }
      },
    });
  }

  buscarPerfilProspecto(cedula: string): void {
    this._prospectService.searchProspectPerfil(cedula).subscribe({
      next: (prospectoResponse: MicroResponse<ProspectResponse>) => {
        if (!prospectoResponse?.data) {
          this.buscarPerfilPublico(cedula);
          return;
        }
        const control = this.registerForm['controls']['cedula'];
        this.perfilProspecto = prospectoResponse?.data;
        control.setErrors({ prospectoExiste: true });
        this.defaultFirstName =
          this.perfilProspecto.identificationInfo.firstName;
        this.defaultLastName = this.perfilProspecto.identificationInfo.lastName;
        this.isRecuperarRegistro = true;
        this.createAccount = false;
        const prospectData: SimpleProspectInfo = {
          id: this.perfilProspecto.id,
          firstName: this.perfilProspecto.identificationInfo.firstName,
          lastName: this.perfilProspecto.identificationInfo.lastName,
          email: this.perfilProspecto.email,
        };
        sessionStorage.setItem('prospectData', JSON.stringify(prospectData));
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.NotFound) {
          this.buscarPerfilPublico(cedula);
        }
      },
    });
  }

  buscarPerfilPublico(cedula: string): void {
    this._usersService.checkRuc(cedula).subscribe({
      next: response => {
        const total = response.body.hits.total.value;
        if (total === 0) {
          const control = this.registerForm['controls']['cedula'];
          this.openWarningCedula();
          this.createAccount = false;
          this.isAlready = false;
          this.isRecuperarRegistro = false;
          control.setErrors({ cedulaNoEncontrada: true });
          return;
        }
        const info = response.body.hits.hits;
        this.perfilPublico = this.extractEconomicActivity(info);
      },
      error: (err: HttpErrorResponse) => {
        if (err.status !== HttpStatusCode.NotFound) {
          return;
        }
        const control = this.registerForm['controls']['cedula'];
        this.openWarningCedula();
        this.createAccount = false;
        this.isAlready = false;
        this.isRecuperarRegistro = false;
        control.setErrors({ cedulaNoEncontrada: true });
      },
    });
  }

  checkCelular(): void {
    const control = this.registerForm['controls']['celular'] as any;
    const valor = control.value;
    if (control.valid && valor.length === 10) {
      this._usersService.buscarCelular(valor).subscribe({
        next: value => {
          if (control.hasError('celularExiste'))
            delete control.errors.emailExiste;
          if (!value) return;
          control.setErrors({ celularExiste: true });
        },
        error: (err: HttpErrorResponse) => {
          if (
            err.status === HttpStatusCode.NotFound &&
            control.hasError('celularExiste')
          ) {
            delete control.errors.emailExiste;
          }
        },
      });
    }
  }

  checkEmail() {
    let control: any;
    if (!this.cambiarForm) {
      control = this.registerForm.get('email') as any;
    } else {
      control = this.cambiarForm.get('nuevoEmail') as any;
    }
    const valor = control.value.toLowerCase();
    if (control.valid) {
      this._usersService.checkInfo(valor).subscribe({
        next: emailResponse => {
          if (emailResponse !== null) {
            control.setErrors({ emailExiste: true });
          } else {
            if (control.hasError('emailExiste')) {
              delete control.errors.emailExiste;
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === HttpStatusCode.NotFound) {
            if (control.hasError('emailExiste')) {
              delete control.errors.emailExiste;
            }
          }
        },
      });
    }
  }

  enableInfo(): void {
    this.registerForm['controls']['fechaExpiracionCedula'].reset();
    this.registerForm['controls']['fechaExpiracionCedula'].enable();
    this.registerForm['controls']['firstName'].reset();
    this.registerForm['controls']['firstName'].enable();
    this.registerForm['controls']['lastName'].reset();
    this.registerForm['controls']['lastName'].enable();
    this.registerForm['controls']['celular'].reset();
    this.registerForm['controls']['celular'].enable();
    this.registerForm['controls']['genero'].reset();
    this.registerForm['controls']['genero'].enable();
  }

  resetSecurityFilters() {
    this.registerForm['controls']['color'].reset();
    this.registerForm['controls']['mascota'].reset();
    this.registerForm['controls']['fruta'].reset();
    this.registerForm['controls']['email'].reset();
    this.registerForm['controls']['password'].reset();
    this.registerForm['controls']['passwordConfirm'].reset();
  }

  checkNombreCompleto(): void {
    const controlFirst = this.registerForm['controls']['firstName'];
    const controlLast = this.registerForm['controls']['lastName'];
    if (controlFirst.value && controlLast.value) {
      const valorNombre = controlFirst.value.trim();
      const valorApellidos = controlLast.value.trim();
      if (
        valorNombre &&
        valorApellidos &&
        this.perfilPublico[0] &&
        this.perfilPublico[0].razonSocial
      ) {
        const nombreCompleto = valorApellidos + ' ' + valorNombre;
        if (nombreCompleto !== this.perfilPublico[0].razonSocial) {
          controlFirst.setErrors({ nombreNoCoincide: true });
          controlLast.setErrors({ nombreNoCoincide: true });
        } else {
          if (controlFirst.hasError('nombreNoCoincide')) {
            controlFirst.updateValueAndValidity({ onlySelf: true });
          }
          if (controlLast.hasError('nombreNoCoincide')) {
            controlLast.updateValueAndValidity({ onlySelf: true });
          }
        }
      }
    }
  }

  validPais(): void {
    const control = this.registerForm['controls']['paisesId'];
    const valor = control.value;
    this.isValidPais = true;
    let res = false;
    if (this.paises) {
      this.paises.forEach(pais => {
        if (pais.id === valor) {
          this.paisSeleccionado = pais;
          return;
        }
      });
      res = this.paisSeleccionado.iso3 === 'ECU';
      this.showNextButton = res;
      if (res) {
        control.setErrors(null);
      } else {
        control.setErrors({ notPais: true });
      }
    }
  }

  isSelectPaisValid(): boolean {
    return this.isValidPais;
  }

  atrasPais(event: any): void {
    event.preventDefault();
    this._router.navigate(['/auth/login']);
  }

  atrasInfo(event: any): void {
    event.preventDefault();
    this.isSelectPais = true;
    this.isInfo = false;
    this.isFiltroSeguridad = false;
    this.isFinal = false;
    this.isPin = false;
    this.createAccount = false;
    this.isAlready = false;
    this.reiniciarMensajesValidacion(this.registerForm);
  }

  atras(event: any): void {
    event.preventDefault();
    this.isSelectPais = false;
    this.isInfo = false;
    this.isFiltroSeguridad = false;
    this.isFinal = false;
    this.createAccount = false;
    this.isAlready = false;
  }

  processPin(pinCode: string) {
    this.registerForm.patchValue({ pinCode: pinCode });
  }

  // eslint-disable-next-line
  onSubmit(): void {
    this.isLoading = true;
    const params = this.registerForm.value;
    let gender = null;

    switch (params.genero) {
      case 'FEMENINO':
        gender = 1;
        break;
      case 'MASCULINO':
        gender = 2;
        break;
      case 'OTRO':
        gender = 3;
        break;
      default:
        gender = 0;
        break;
    }
    const paramsObject: ProspectRequest = {
      email: params.email.trim().toLowerCase(),
      password: params.password,
      telephone: params.celular.trim(),
      color: params.color,
      pet: params.mascota,
      fruit: params.fruta,
      pinCode: params.pinCode,
      identificationInfo: {
        identificationCard: params.cedula.trim(),
        firstName: params.firstName.trim(),
        lastName: params.lastName.trim(),
        countryId: params.paisesId,
        expirationDate: this.dateFormatter(params.fechaExpiracionCedula),
        genderId: gender,
        createdByUserId: 1,
        economicActivityInfo: this.getEconomicActivityList(),
      },
    };
    this._prospectService.prospectRegister(paramsObject).subscribe(
      response => {
        this.account = response;
        this.isInfo = false;
        this.isFiltroSeguridad = false;
        this.isFinal = true;
        this.isPin = false;
        this.createAccount = false;
        this.prospectDataId = response.data.id;
        this.sendEmail();
        this.email = paramsObject.email || '';
        this.step = this.regiStep.emailSent;
      },
      () => {
        this.isLoading = false;
        this._snackBar.open(
          'Ha ocurrido un error y no se completó el registro, inténtalo más tarde',
          undefined,
          { horizontalPosition: 'right', panelClass: ['snack-error'] },
        );
      },
    );
  }

  next(event: any): void {
    event.preventDefault();
    switch (this.step) {
      case this.regiStep.createAccount: {
        if (this.isSelectPaisValid()) {
          this.registerForm['controls']['cedula'].reset();
          this.reiniciarMensajesValidacion(this.registerForm);
          this.showNextButton = false;
          this.isClassButton = true;
          if (this.DatePickerComp) this.DatePickerComp.resetComponent();
          this.step++;
        }
        break;
      }
      case this.regiStep.registerUser: {
        if (this.formValidFirstStep()) {
          this.showNextButton = false;
          this.step++;
        }
        break;
      }
      case this.regiStep.securityFilter: {
        if (this.formValidSecondStep()) {
          this.showNextButton = false;
          this.step++;
        }
        break;
      }
      case this.regiStep.securityPin: {
        this.showNextButton = false;
        this.step++;
        break;
      }
    }
  }

  previous(event: any): void {
    if (event !== null) {
      event.preventDefault();
    }
    switch (this.step) {
      case this.regiStep.createAccount: {
        this._router.navigate(['/auth/login']);
        break;
      }
      case this.regiStep.registerUser: {
        this.registerForm.controls['paisesId'].reset();
        this.reiniciarMensajesValidacion(this.registerForm);
        this.isAlready = false;
        this.isClassButton = true;
        this.step--;
        break;
      }
      case this.regiStep.securityFilter: {
        this.resetSecurityFilters();
        this.step--;
        break;
      }
      case this.regiStep.securityPin: {
        this.boardPinCode = '';
        this.registerForm['controls']['validado'].setValue(false);
        this.registerForm['controls']['validado'].updateValueAndValidity();
        this.step--;
        break;
      }
      case this.regiStep.emailSent: {
        this.isShowCambiar = false;
        this.step--;
        break;
      }
    }
  }

  enableNextButton(): boolean {
    return (
      this.showNextButton ||
      (this.formValidFirstStep() && this.step === this.regiStep.registerUser) ||
      (this.formValidSecondStep() && this.step === this.regiStep.securityFilter)
    );
  }

  showPrevButton() {
    return !(
      (this.step === this.regiStep.securityPin && this.registerForm.valid) ||
      this.step === this.regiStep.emailSent ||
      this.step === this.regiStep.securityPin
    );
  }

  formValidFirstStep(): boolean {
    return (
      this.registerForm.get('cedula')?.status === 'VALID' &&
      this.registerForm.get('fechaExpiracionCedula')?.status === 'VALID' &&
      this.registerForm.get('firstName')?.status === 'VALID' &&
      this.registerForm.get('lastName')?.status === 'VALID' &&
      this.registerForm.get('celular')?.status === 'VALID' &&
      this.registerForm.get('genero')?.status === 'VALID'
    );
  }

  formValidSecondStep(): boolean {
    return (
      this.registerForm.get('color')?.status === 'VALID' &&
      this.registerForm.get('mascota')?.status === 'VALID' &&
      this.registerForm.get('fruta')?.status === 'VALID' &&
      this.registerForm.get('email')?.status === 'VALID' &&
      this.registerForm.get('password')?.status === 'VALID' &&
      this.registerForm.get('passwordConfirm')?.status === 'VALID'
    );
  }

  checkPassword(): void {
    this.showPassword = !this.showPassword;
  }

  validPassword() {
    const password = this.registerForm['controls']['password'];
    const passwordValid = this.registerForm['controls']['passwordConfirm'];
    if (password.value === passwordValid.value) {
      this.samePassword = true;
    } else {
      this.samePassword = false;
    }
  }

  selectFecha(fecha: string): void {
    this.registerForm.patchValue({ fechaExpiracionCedula: fecha });
  }

  cambiar(): void {
    this.cambiarForm = this._formBuilder.group({
      nuevoEmail: ['', [Validators.required, Validators.email]],
    });
    this.isShowCambiar = true;
    this.isLoading = false;
  }

  onSubmitCambiar(): void {
    this.isLoading = true;
    this.isLoading = true;
    const control = this.cambiarForm.get('nuevoEmail') as any;
    const valor = control.value.toLowerCase();
    if (control.valid) {
      this._usersService.checkInfo(valor).subscribe({
        next: (emailResponse: MicroResponse<UserResponse>) => {
          if (emailResponse) {
            control.setErrors({ emailExiste: true });
            this.isLoading = false;
          } else {
            if (control.hasError('emailExiste')) {
              delete control.errors.emailExiste;
            }
            this.saveEmail();
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === HttpStatusCode.NotFound) {
            if (control.hasError('emailExiste')) {
              delete control.errors.emailExiste;
            }
            this.saveEmail();
          }
        },
      });
    }
  }

  reiniciarMensajesValidacion(control: any): void {
    this.isRecuperarRegistro = false;
    this.enableInfo();
    if (control.hasError('cedulaExiste')) {
      delete control.errors.cedulaExiste;
    }
    if (control.hasError('emailExiste')) {
      delete control.errors.emailExiste;
    }
    if (control.hasError('prospectoExiste')) {
      delete control.errors.prospectoExiste;
    }
    if (control.hasError('cedulaNoEncontrada')) {
      delete control.errors.cedulaNoEncontrada;
    }
    if (control.hasError('celularExiste')) {
      delete control.errors.celularExiste;
    }
    if (control.hasError('emailExiste')) {
      delete control.errors.emailExiste;
    }
    control.updateValueAndValidity({ onlySelf: true });
  }

  sendEmail(): void {
    this.isSendingMail = true;
    this._prospectService
      .sendEmail(this.prospectDataId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.isSendingMail = false;
        }),
      )
      .subscribe({
        next: () => {
          this.checkEmailRegistered();
        },
        error: error => {
          console.error('Error al enviar el correo: ', error);
        },
      });
  }

  private saveEmail(): void {
    this.email = this.cambiarForm.get('nuevoEmail')?.value;
    this._prospectService
      .saveEmail(this.prospectDataId, { email: this.email })
      .subscribe({
        next: (response: MicroResponse<boolean>) => {
          if (response.data) {
            this.sendEmail();
            this.isShowCambiar = false;
            this.cambiarForm.get('nuevoEmail')?.reset();
          } else {
            this.isLoading = false;
            const control = this.cambiarForm['controls']['nuevoEmail'];
            control.setErrors({ emailExiste: true });
          }
        },
        error: error => {
          this.isLoading = false;
          this._snackBar.open(
            'Hubo un error con el envío del correo en la dirección especificada, inténtalo de nuevo',
            undefined,
            { horizontalPosition: 'right', panelClass: ['snack-error'] },
          );
        },
      });
  }

  private checkEmailRegistered() {
    const intervalo = setInterval(() => {
      if (!this.isEmailRegistered) {
        const userEmail = this._usersService.getUserByEmail(this.email).pipe(
          filter(response => !(response === null)),
          take(1),
        );
        userEmail.subscribe({
          next: (response: MicroResponse<UserResponse>) => {
            this.isEmailRegistered = this.email === response.data.email;
            this.isShowCambiar = false;
          },
        });
      } else {
        clearInterval(intervalo);
      }
    }, 7000);
  }

  private dateFormatter(date: string): string {
    let dt = '';
    if (date.length === 0) {
      return dt;
    }
    const parts = date.split(new RegExp('/|-'));
    if (parts[2].length === 4) {
      dt = parts.reverse().join('-');
    } else if (parts[0].length === 4) {
      dt = parts.join('-');
    }
    return dt;
  }

  receiveValue(value: string) {
    if (value.toString().match('Atras')) {
      this.previous(null);
      return;
    }
    if (value.toString().match('Borrar')) {
      this.boardPinCode = this.boardPinCode.slice(0, -1);
      value = '';
    }
    if (this.boardPinCode.length === 6) {
      value = '';
    }
    this.boardPinCode = this.boardPinCode + value;
    this.registerForm.patchValue({ pinCode: this.boardPinCode });
  }

  hasCedulaError(): boolean | undefined {
    const cedulaControl = this.registerForm.get('cedula');
    return (
      cedulaControl?.invalid && (cedulaControl?.touched || cedulaControl?.dirty)
    );
  }

  hasNombreError(): boolean | undefined {
    const nombreControl = this.registerForm.get('firstName');
    return (
      nombreControl?.invalid && (nombreControl?.touched || nombreControl?.dirty)
    );
  }

  hasApellidoError(): boolean | undefined {
    const apellidoControl = this.registerForm.get('lastName');
    return (
      apellidoControl?.invalid &&
      (apellidoControl?.touched || apellidoControl?.dirty)
    );
  }

  hasCelError(): boolean | undefined {
    const celularControl = this.registerForm.get('celular');
    return (
      celularControl?.invalid &&
      (celularControl?.touched || celularControl?.dirty)
    );
  }

  hasGeneroError(): boolean | undefined {
    const generoControl = this.registerForm.get('genero');
    return (
      generoControl?.invalid && (generoControl?.touched || generoControl?.dirty)
    );
  }

  hasColorError(): boolean | undefined {
    const colorControl = this.registerForm.get('color');
    return (
      colorControl?.invalid && (colorControl?.touched || colorControl?.dirty)
    );
  }

  hasMascotaError(): boolean | undefined {
    const mascotaControl = this.registerForm.get('mascota');
    return (
      mascotaControl?.invalid &&
      (mascotaControl?.touched || mascotaControl?.dirty)
    );
  }

  hasFrutaError(): boolean | undefined {
    const frutaControl = this.registerForm.get('fruta');
    return (
      frutaControl?.invalid && (frutaControl?.touched || frutaControl?.dirty)
    );
  }

  hasEmailError(): boolean | undefined {
    const emailControl = this.registerForm.get('email');
    return (
      emailControl?.invalid && (emailControl?.touched || emailControl?.dirty)
    );
  }

  hasPasswordError(): boolean | undefined {
    const passwordControl = this.registerForm.get('password');
    return (
      passwordControl?.invalid &&
      (passwordControl?.touched || passwordControl?.dirty)
    );
  }

  hasPasswordConfirmError(): boolean | undefined {
    const passwordConfirmControl = this.registerForm.get('passwordConfirm');
    return (
      passwordConfirmControl?.invalid &&
      (passwordConfirmControl?.touched || passwordConfirmControl?.dirty)
    );
  }

  hasCambiarEmailError(): boolean | undefined {
    const emailControl = this.cambiarForm.get('nuevoEmail');
    return (
      emailControl?.invalid && (emailControl?.touched || emailControl?.dirty)
    );
  }

  getCedulaErrorTooltip(): string {
    const cedulaControl = this.registerForm.get('cedula');
    if (cedulaControl?.hasError('required')) {
      return 'Cedula es requerida';
    } else if (cedulaControl?.hasError('pattern')) {
      return 'Cedula no valida';
    } else if (cedulaControl?.hasError('minlength')) {
      return 'Cedula debe tener 10 digitos';
    } else if (cedulaControl?.hasError('maxlength')) {
      return 'Cedula debe tener 10 digitos';
    } else if (cedulaControl?.hasError('cedulaNoValida')) {
      return 'Cedula no tiene estructura valida';
    } else if (cedulaControl?.hasError('cedulaNoEncontrada')) {
      return 'Cedula no encontrada';
    } else if (cedulaControl?.hasError('cedulaExiste')) {
      return 'Este numero de cedula ya es usuario de idempier';
    } else if (cedulaControl?.hasError('prospectoExiste')) {
      return 'Este número de cédula ya está registrado';
    }
    return '';
  }

  getNombreErrorTooltip(): string {
    const nombreControl = this.registerForm.get('firstName');
    if (nombreControl?.hasError('required')) {
      return 'Nombre es requerido';
    } else if (nombreControl?.hasError('nombreNoCoincide')) {
      return 'Nombre no coincide con la cedula ingresada';
    }
    return '';
  }

  getApellidoErrorTooltip(): string {
    const apellidoControl = this.registerForm.get('lastName');
    if (apellidoControl?.hasError('required')) {
      return 'Apellido es requerido';
    } else if (apellidoControl?.hasError('nombreNoCoincide')) {
      return 'Apellido no coincide con la cedula ingresada';
    }
    return '';
  }

  getCelErrorTooltip(): string {
    const celularControl = this.registerForm.get('celular');
    if (celularControl?.hasError('required')) {
      return 'Celular es requerido';
    } else if (celularControl?.hasError('celularExiste')) {
      return 'Este numero de celular ya es usuario de idempier';
    }
    return '';
  }

  getGeneroErrorTooltip(): string {
    const generoControl = this.registerForm.get('genero');
    if (generoControl?.hasError('required')) {
      return 'El genero es requerido';
    }
    return '';
  }

  getColorErrorTooltip(): string {
    const colorControl = this.registerForm.get('color');
    if (colorControl?.hasError('required')) {
      return 'Color es requerido';
    }
    return '¡No reveles tu Color!';
  }

  getMascotaErrorTooltip(): string {
    const mascotaControl = this.registerForm.get('mascota');
    if (mascotaControl?.hasError('required')) {
      return 'Mascota es requerido';
    }
    return '¡No reveles tu Mascota!';
  }

  getFrutaErrorTooltip(): string {
    const frutaControl = this.registerForm.get('fruta');
    if (frutaControl?.hasError('required')) {
      return 'Fruta es requerido';
    }
    return '¡No reveles tu Fruta!';
  }

  getEmailErrorTooltip(): string {
    const emailControl = this.registerForm.get('email');
    if (emailControl?.hasError('required')) {
      return 'Email es requerido';
    } else if (emailControl?.hasError('email')) {
      return 'Email no valido';
    } else if (emailControl?.hasError('emailExiste')) {
      return 'Este Email ya es usuario de idempier';
    }
    return '';
  }

  getPasswordErrorTooltip(): string {
    const passwordControl = this.registerForm.get('password');
    if (passwordControl?.hasError('required')) {
      return 'La contraseña es requerida';
    } else if (passwordControl?.hasError('pattern')) {
      return 'La contraseña debe contener entre 8 y 16 caracteres y tener por lo menos 1 Mayúscula, 1 Minúscula, 1 Numero, 1 carácter especial (@$%¡*¿)';
    }
    return '';
  }

  getPasswordConfirmErrorTooltip(): string {
    const passwordConfirmControl = this.registerForm.get('passwordConfirm');
    if (passwordConfirmControl?.hasError('required')) {
      return 'La confirmacion de Contraseña es requerido';
    } else if (
      !passwordConfirmControl?.hasError('required') &&
      passwordConfirmControl?.hasError('passwordsNotMatching')
    ) {
      return 'Contraseñas no coinciden';
    }
    return '';
  }

  getCambiarEmailErrorTooltip(): string {
    const emailControl = this.cambiarForm.get('nuevoEmail');
    if (emailControl?.hasError('required')) {
      return 'Email es requerido';
    } else if (emailControl?.hasError('email')) {
      return 'Email no valido';
    } else if (emailControl?.hasError('emailExiste')) {
      return 'Este Email ya es usuario de idempier';
    }
    return '';
  }

  private filtersPageResets() {
    this.filtersPage.subscribe({
      next: value => {
        value.page = 0;
        value.size = 10;
        value.sortBy = 'countryName';
        value.sortDir = 'asc';
        value.search = '';
      },
    });
  }

  private getEconomicActivityList(): Array<EconomicActivityProspectRequest> {
    const json: Array<EconomicActivityProspectRequest> = [];
    if (this.perfilPublico) {
      this.perfilPublico.forEach(actividadEconomica => {
        json.push(this.getEconomicActivity(actividadEconomica));
      });
    }
    return json;
  }

  private getEconomicActivity(
    actEco: ActividadEconomica,
  ): EconomicActivityProspectRequest {
    return {
      ruc: actEco.ruc,
      businessName: actEco.razonSocial,
      taxpayerType: actEco.tipoContribuyente,
      province: actEco.provincia,
      canton: actEco.canton,
      parish: actEco.parroquia,
      street: actEco.calle,
      number: actEco.numero,
      intersection: actEco.interseccion,
      address: actEco.direccion,
      tradeName: actEco.nombreComercial,
      forcedAccounting: actEco.obligadoContabilidad,
      economicActivityDescription: actEco.actividadEconomica,
      updateDate: this.dateFormatter(actEco.fechaActualizacion),
      taxpayerStatus: actEco.estadoContribuyente,
      taxpayerClass: actEco.claseContribuyente,
      activityStartDate: this.dateFormatter(actEco.fechaInicioActividades),
      finalSuspensionDate: this.dateFormatter(actEco.fechaSuspensionDefinitiva),
      activityRestartDate: this.dateFormatter(actEco.fechaReinicioActividades),
      businessFancyName: actEco.nombreFantasiaComercial,
      stablishmentStatus: actEco.estadoEstablecimiento,
      ciuuCode: actEco.codigoCiuu,
    };
  }

  private extractEconomicActivity(hits: any): Array<ActividadEconomica> {
    const json: Array<ActividadEconomica> = [];
    hits.forEach((hit: any) => {
      json.push(hit._source);
    });
    return json;
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
